<script setup lang="ts">
import { ref, watch } from "vue";

import { BaseToggle } from "@/shared/components/temparary/components";
import Button from "@/shared/components/button/Button.vue";
import Close from "@/shared/components/svgs/Close.vue";
import { usePopupManager } from "@/shared/composables/usePopupManager";
import { useSeminarMode } from "@/shared/composables/useSeminarMode";
import type { BasePopupProps } from "@/shared/plugins/interface";

const props = defineProps<BasePopupProps>();

const { closePopup } = usePopupManager();
const { isSeminarModeEnabled, setSeminarModeEnabled } = useSeminarMode();

const seminarModeState = ref(isSeminarModeEnabled.value);

watch(isSeminarModeEnabled, (enabled) => {
    seminarModeState.value = enabled;
});

const handleToggleSeminarMode = (enabled: boolean) => {
    seminarModeState.value = enabled;
    setSeminarModeEnabled(enabled);
};

const handleClosePopup = () => {
    closePopup(props.closeKey);
};
</script>

<template>
    <section class="flex flex-col gap-[2.4rem] w-full min-w-[32rem]">
        <div class="flex flex-col gap-[1.2rem]">
            <div class="flex items-center justify-between">
                <h2 class="text-lg font-semibold font-pretended text-primary-black">
                    세미나 모드 설정
                </h2>
                <button
                    type="button"
                    class="cursor-pointer size-fit"
                    aria-label="닫기"
                    @click="handleClosePopup"
                >
                    <Close />
                </button>
            </div>
            <div class="w-full h-[0.1rem] bg-custom-border-gray"></div>
        </div>

        <div class="flex items-center justify-between gap-[1.6rem] py-[0.8rem]">
            <p class="text-[1.4rem] font-semibold font-pretended text-primary-black">
                세미나 모드
            </p>
            <BaseToggle
                :value="seminarModeState"
                @emit-toggle-state="handleToggleSeminarMode"
            />
        </div>

        <p class="text-[1.3rem] font-normal font-pretended text-t-basic">
            ON 상태에서는 학생 목록의 휴대전화번호가 마스킹되고, 학생 상세 진입 시 커리큘럼 탭이
            먼저 열립니다.
        </p>

        <Button
            type="button"
            color="primary"
            value="확인"
            :is-width-full="true"
            @click="handleClosePopup"
        />
    </section>
</template>
